/**
* Renders pulsing skeleton placeholders for the challenge list while data loads.
* @example
* ChallengeListSkeleton()
* <div className="animate-pulse space-y-4">...</div>
* @returns {JSX.Element} A group of placeholder cards representing loading challenges.
*/
const ChallengeListSkeleton = () => {
  return (
    <div className="animate-pulse space-y-4">
      {[1, 2, 3].map((i) => (
        <div key={i} className="bg-background-secondary rounded-lg p-6 border border-border-primary">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <div className="h-6 bg-background-tertiary rounded w-2/3 mb-3" />
              <div className="h-4 bg-background-tertiary rounded w-full mb-2" />
              <div className="h-4 bg-background-tertiary rounded w-5/6" />
            </div>
            <div className="w-24 h-8 bg-background-tertiary rounded ml-4" />
          </div>
          
          <div className="flex items-center gap-4 mt-4">
            <div className="h-4 bg-background-tertiary rounded w-32" />
            <div className="h-4 bg-background-tertiary rounded w-24" />
            <div className="h-4 bg-background-tertiary rounded w-28" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChallengeListSkeleton;
